import React, {Fragment} from 'react';
import {EarlyLandingPage, LandingPage, About, NotFoundPage, UserProfilePage, UserProfileEdit, UserVideoEdit, DiscoveryPage, Resources, EventPage, ResetPasswordPage, AcctActivationPage, OnboardingPage, AccountSettingsPage, PrivacyPolicyPage, CompanyHomePage, ProductHistoryPage} from 'pages';
import {NavBar} from 'components';
import ScrollToTop from './ScrollToTop';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import 'app/styling/global.scss';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    Outlet,
    useLocation,
  } from "react-router-dom";

// Layout wrapper that conditionally shows NavBar
const LayoutWithNav = () => {
    return (
        <>
            <NavBar/>
            <Outlet />
        </>
    );
};

export default function App() {
    if (process.env.REACT_APP_EARLY_PRODUCTION === 'true') {
        return (
                <Router>
                    <Fragment>
                        <ScrollToTop />
                        <Routes>
                            {/* Company Homepage - standalone without NavBar */}
                            <Route path="/" element={<CompanyHomePage/>} />
                            
                            {/* Routes with NavBar */}
                            <Route element={<LayoutWithNav />}>
                                {/* Product pages (original SideJawn) */}
                                <Route path="/product" element={<EarlyLandingPage/>} />
                                <Route path="/product/history" element={<ProductHistoryPage/>} />
                                
                                {/* Discovery */}
                                <Route path="/discovery" element={<Navigate to="/discovery/community?name=Code+%26+Coffee" replace />}/>
                                <Route path="/discovery/:tab" element={<DiscoveryPage/>} />
                                <Route path="/onboarding/:userId" element={<OnboardingPage/>} />
                                
                                {/* Supplementary pages */}
                                <Route path="/about" element={<About/>} />
                                <Route path="/privacy-policy" element={<PrivacyPolicyPage/>} />
                                
                                {/* Profile pages */}
                                <Route path="/profile/:userId" element={<UserProfilePage/>} />
                                <Route path="/profile/:userId/edit" element={<UserProfileEdit/>} />
                                <Route path="/profile/:userId/video/edit" element={<UserVideoEdit/>} />
                                <Route path="/profile/:userId/settings/" element={<AccountSettingsPage/>} />
                                
                                {/* Operational pages */}
                                <Route path="/password-reset" element={<ResetPasswordPage/>} />
                                <Route path="/acct-activation" element={<AcctActivationPage/>} />
                                <Route path="/linkedin-auth/signup" element={<LinkedInCallback/>} />
                                <Route path="/linkedin-auth/login" element={<LinkedInCallback/>} />
                                <Route path="*" element={<NotFoundPage/>} />
                            </Route>
                        </Routes>
                    </Fragment>
                </Router>
        );
    }
    else {
        return (
            <Router>
                <NavBar/>
                <Routes>
                    <Route exact path="/">
                        <LandingPage/> 
                    </Route>
                    <Route exact path="/about">
                        <About/>
                    </Route>
                </Routes>
            </Router>
        );
    }
}
